import { apiConfig } from '../../config';
import { APIService } from '../api/API';

interface MarkdownDocument {
    id: string;
    content: string;
}

interface MarkdownResponse {
    content: string;
}

// Define a type for the error object
interface ErrorWithDetails {
    message?: string;
    name?: string;
    type?: string;
    [key: string]: unknown;
}

const apiService = new APIService(apiConfig.serverURLs.MAX);
const cachedMarkdownDocument: Record<string, MarkdownDocument> = {};

export const getMarkdownCMSDocument = async (
    id: string
): Promise<MarkdownDocument> => {
    if (cachedMarkdownDocument[id]) {
        return cachedMarkdownDocument[id];
    }

    try {
        const response = await apiService.get<MarkdownResponse>(
            'getMarkdownCMSDocument',
            {
                params: { id },
            }
        );

        if (!response?.data) {
            throw new Error('Invalid response data');
        }

        const result = {
            id,
            content: response.data.content,
        };

        cachedMarkdownDocument[id] = result;
        return result;
    } catch (error: unknown) {
        // Cast error to our defined type
        const errorWithDetails = error as ErrorWithDetails;

        // Don't log network or abort errors
        if (
            errorWithDetails.type === 'NETWORK_ERROR' ||
            errorWithDetails.name === 'AbortError'
        ) {
            return {
                id,
                content: '',
            };
        }

        // Log other errors
        global.DD_RUM?.addError?.('Failed to load markdown CMS document', {
            error,
            id,
            message: errorWithDetails.message,
            name: errorWithDetails.name,
            type: errorWithDetails.type,
        });

        return {
            id,
            content: '',
        };
    }
};
